export default "__VITE_PUBLIC_ASSET__54ac9a23__"